import { useEffect, useState } from "react";

// Mock QR image for UI testing
const MOCK_QR =
  "https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=CompanyPaymentQR";

const QRSettings = () => {
  const [qrFile, setQrFile] = useState(null);
  const [qrPreview, setQrPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [currentQR, setCurrentQR] = useState(null);

  // Load mock QR on mount
  useEffect(() => {
    setTimeout(() => {
      setCurrentQR(MOCK_QR);
    }, 500);
  }, []);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      setMessage("Please upload a valid image file");
      return;
    }

    setQrFile(file);
    setQrPreview(URL.createObjectURL(file));
    setMessage("");
  };

  const handleUpload = () => {
    if (!qrFile) {
      setMessage("Please select a QR image first");
      return;
    }

    setLoading(true);
    setMessage("");

    // Fake API delay
    setTimeout(() => {
      setCurrentQR(qrPreview);
      setQrFile(null);
      setQrPreview(null);
      setLoading(false);
      setMessage("QR code updated successfully!");
    }, 1500);
  };

  return (
    <div className="w-full max-w-5xl mx-auto p-4 sm:p-6 space-y-6">
      <h1 className="text-lg sm:text-xl font-semibold">
        Payment QR
      </h1>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        
        {/* Current QR */}
        <div className="border rounded-xl p-4 flex flex-col items-center justify-center">
          <p className="text-sm font-medium mb-3">
            Current Company QR
          </p>

          {currentQR ? (
            <img
              src={currentQR}
              alt="Company QR"
              className="w-40 h-40 sm:w-48 sm:h-48 lg:w-56 lg:h-56 object-contain"
            />
          ) : (
            <p className="text-sm text-gray-400">
              Loading QR...
            </p>
          )}
        </div>

        {/* Upload Section */}
        <div className="border rounded-xl p-4 space-y-4">
          <p className="text-sm font-medium">
            Upload New QR
          </p>

          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            className="block w-full text-sm"
          />

          {/* Preview */}
          {qrPreview && (
            <div className="flex justify-center">
              <img
                src={qrPreview}
                alt="QR Preview"
                className="w-32 h-32 sm:w-40 sm:h-40 lg:w-48 lg:h-48 object-contain border rounded-lg"
              />
            </div>
          )}

          {/* Upload Button */}
          <button
            onClick={handleUpload}
            disabled={loading}
            className={`w-full py-3 rounded-xl text-white text-sm sm:text-base transition ${
              loading
                ? "bg-gray-400"
                : "bg-indigo-600 hover:bg-indigo-700"
            }`}
          >
            {loading ? "Uploading..." : "Upload / Update QR Code"}
          </button>

          {/* Message */}
          {message && (
            <p
              className={`text-sm text-center ${
                message.includes("success")
                  ? "text-green-600"
                  : "text-red-600"
              }`}
            >
              {message}
            </p>
          )}

          <p className="text-xs sm:text-sm text-gray-500 text-center">
            Visible to all sales persons
          </p>
        </div>
      </div>
    </div>
  );
};

export default QRSettings;
